import { useState } from 'react';
import type { SyntheticEvent } from 'react';
import styles from './SendScheduleConfirmModal.module.css';

interface SendScheduleConfirmModalProps {
  onConfirm: (data: { name: string; description: string; classId: string }) => void;
  onCancel: () => void;
  defaultName: string;
  selectedClass: { class_id: string; [key: string]: unknown };
}

export default function SendScheduleConfirmModal({ onConfirm, onCancel, defaultName, selectedClass }: SendScheduleConfirmModalProps) {
  const [scheduleName, setScheduleName] = useState(defaultName);
  const [description, setDescription] = useState('');

  const handleSubmit = (e: SyntheticEvent) => {
    const classId = selectedClass.class_id;
    e.preventDefault();
    onConfirm({
      name: scheduleName,
      description,
      classId
    });
  };

  return (
    <div className={styles.modalOverlay}>
      <div className={styles.container}>
        <div className={styles.content}>
          <h2>Stundenplan versenden und speichern</h2>
          <p>Der Stundenplan wird an alle zugewiesenen Studenten versendet und automatisch gespeichert.</p>

          <div className={styles.formContainer}>
            <form onSubmit={handleSubmit}>
              <label>
                Name des Stundenplans:
                <input
                  type="text"
                  value={scheduleName}
                  onChange={(e) => setScheduleName(e.target.value)}
                  required
                />
              </label>
              <label>
                Beschreibung (optional):
                <textarea
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                  placeholder="Beschreibung hinzufügen..."
                />
              </label>
            </form>
          </div>

          <div className={styles.buttons}>
            <button
              onClick={onCancel}
              className={styles.cancelButton}
            >
              Abbrechen
            </button>
            <button
              onClick={handleSubmit}
              className={styles.confirmButton}
            >
              Versenden & Speichern
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
